import React, { useState, useEffect } from 'react';
import {
  Box,
  RadioGroup,
  FormControl,
  FormLabel,
  FormControlLabel,
  Radio,
  Typography,
  //Checkbox,
  TextField,
  //Stack,
  Grid,
  Button,
  Container
} from '@mui/material';
import MuiPhoneNumber from 'material-ui-phone-number-2';
//import AddIcon from '@mui/icons-material/Add';
// import MultipleSelectChip from '../../components/mutiselect1';
//import { LANGUAGES, getNames } from '../../../config/language';
import { useDispatch, useSelector } from 'react-redux';
import { Autocomplete } from '@mui/material';
//import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
//import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useFormik } from 'formik';
import { validateContactInfoForm } from './ValidateContactInfoForm';
import { KeyboardArrowLeft } from '@mui/icons-material';
// import { useParams } from 'react-router-dom';
import * as caseActions from '../../../actions/caseActions';
import * as patientActions from '../../../actions/patientActions';
import * as loginActions from '../../../actions/loginActions';
import { getCountryCode } from '../../../config/country';
import { getUSStateAbbr } from '../../../config/USStates';
import styles from '../dashboardstyles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useNavigate } from 'react-router-dom';
import { RELATIONSHIP, getPhoneTypeText, getPhoneTypeValue } from '../../../config/picklist';
import * as Constants from '../../../config/constants';
import { useSnackbar } from 'notistack';
import Divider from '@mui/material/Divider';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { GENDER } from '../../../config/gender';
import { countries } from '../../../config/country';
import { US_STATES_SORT_BY_NAME } from '../../../config/USStates';

//const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
//const checkedIcon = <CheckBoxIcon fontSize="small" />;

const GuardianInfo = () => {
  // let { caseId } = useParams();
  // var caseId = props !== undefined && props.caseId !== undefined ? props.caseId : 0;
  // console.log(caseId);
  // redux
  // const dispatch = useDispatch();
  const st = useSelector((state) => state.rootReducer);
  const dispatch = useDispatch();
  const [saveSubmitted, setSaveSubmitted] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  var caseType = st.caseType;

  var option =
    caseType === 'your child' || caseType === 'yourself' || caseType === 'your fetus'
      ? caseType
      : caseType === 'other relative' || caseType === 'other not relative'
      ? 'other relative'
      : 'your fetus';
  useEffect(() => {
    // callback from other callers outside this component
    if (st.saveContactInfo) {
      submitCaseContactInfo(formik.values);
      dispatch(caseActions.setSaveContactInfo(false));
    }
    //banner success message
    if (saveSubmitted && !st.isUpdateCaseLoading && st.updatecontacterror === '') {
      enqueueSnackbar(Constants.UPDATE_CASE_SUCCESS, {
        variant: 'success'
      });
      setSaveSubmitted(false);
    }
  }, [st.saveContactInfo, st.isUpdateCaseLoading, saveSubmitted, st.updatecontacterror]);

  // control navigation target when leave the page
  // const [fromMenu, setFromMenu] = useState(false);
  // flag to see if the page data changed or not
  // const [dataUpdated, setDataUpdated] = useState(false);

  const [showDialog, setShowDialog] = useState(false);

  const detectMobileType = () =>
    /iPhone|iPad|iPod/i.test(navigator.userAgent)
      ? 'iPhone'
      : /Android/i.test(navigator.userAgent)
      ? 'Android'
      : 'Desktop';

  const onMobile = detectMobileType() !== 'Desktop';

  // step 5
  //const [showEmail2, setShowEmail2] = useState(st.patient.email2 !== '' ? true : false);
  const [countryCode, setCountryCode] = useState(
    st !== undefined &&
      st.patient !== undefined &&
      st.patient.phone !== undefined &&
      st.patient.phone !== ''
      ? st.patient.phone.split(' ')[0] !== null
        ? st.patient.phone.slice(0, st.patient.phone.indexOf(' '))
        : '+1'
      : '+1'
  );

  const dateToString = (dt) => {
    // Parse date without timezone
    if (dt === null) {
      dt = new Date();
    }
    var date_to_convert = new Date(
      dt.getUTCFullYear(),
      dt.getUTCMonth(),
      dt.getUTCDate(),
      10,
      0,
      0,
      0
    );
    return date_to_convert.toDateString().slice(4);
  };
  // step 4
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      addressline1: st !== undefined ? st.patient.addressline1 : '',
      addressline2: st !== undefined ? st.patient.addressline2 : '',
      city: st !== undefined ? st.patient.city : '',
      state: st.patient.state,
      province: st.patient.state,
      country:
        st !== undefined && st.patient.country !== undefined && st.patient.country !== ''
          ? st.patient.country
          : 'United States',
      zip: st !== undefined ? st.patient.zip : '',
      secondaryAddressline1: st !== undefined ? st.patient.secondaryAddressline1 : '',
      secondaryAddressline2: st !== undefined ? st.patient.secondaryAddressline2 : '',
      secondaryCity: st !== undefined ? st.patient.secondaryCity : '',
      secondaryState: st.patient.secondaryState,
      secondaryProvince: st.patient.secondaryState,
      secondaryCountry:
        st !== undefined &&
        st.patient.secondaryCountry !== undefined &&
        st.patient.secondaryCountry !== ''
          ? st.patient.secondaryCountry
          : 'United States',
      secondaryZip: st !== undefined ? st.patient.secondaryZip : '',
      email:
        st !== undefined &&
        st.patient !== undefined &&
        st.patient.email !== undefined &&
        st.patient.email !== ''
          ? st.patient.email
          : st !== undefined
          ? st.email
          : '',
      email2:
        st !== undefined &&
        st.patient !== undefined &&
        st.patient.email2 !== undefined &&
        st.patient.email2 !== ''
          ? st.patient.email2
          : '',
      phone:
        st !== undefined && st.patient.phone !== undefined && st.patient.phone !== ''
          ? st.patient.phone
          : st.userDetail !== null &&
            st.userDetail !== undefined &&
            st.userDetail.phone_number !== undefined &&
            st.userDetail.phone_number !== null
          ? st.userDetail.phone_number
          : '',
      phone2:
        st !== undefined && st.patient.phone2 !== undefined && st.patient.phone2 !== ''
          ? st.patient.phone2
          : '',
      phone3:
        st !== undefined && st.patient.phone3 !== undefined && st.patient.phone3 !== ''
          ? st.patient.phone3
          : '',
      phone4:
        st !== undefined && st.patient.phone4 !== undefined && st.patient.phone4 !== ''
          ? st.patient.phone4
          : '',
      phonetype:
        st !== undefined && st.patient.phonetype !== undefined
          ? getPhoneTypeText(st.patient.phonetype)
          : '',
      phonetype2:
        st !== undefined && st.patient.phonetype2 !== undefined
          ? getPhoneTypeText(st.patient.phonetype2)
          : '',
      phonetype3:
        st !== undefined && st.patient.phonetype3 !== undefined
          ? getPhoneTypeText(st.patient.phonetype3)
          : '',
      phonetype4:
        st !== undefined && st.patient.phonetype4 !== undefined
          ? getPhoneTypeText(st.patient.phonetype4)
          : '',
      languages: st !== undefined ? st.patient.languages : [29],
      needInterpreter:
        st !== undefined && st.patient.needInterpreter !== undefined
          ? st.patient.needInterpreter
          : 'N'
    },
    validationSchema: validateContactInfoForm,
    onSubmit: (values) => {
      // alert('Submit UpdateAddress API\n' + JSON.stringify(values, null, 2));
      submitCaseContactInfo(values);
      // reset flag
      dispatch(caseActions.setDataUpdated(false));
      setSaveSubmitted(true);
      // reset fromMenu
      // setFromMenu(false);
    }
  });

  function formatPhoneToSave(countryCode, phone) {
    return (
      phone.substring(0, countryCode.length) +
      ' ' +
      phone.substring(countryCode.length, phone.length).replace(/\s/g, '')
    );
  }
  let navigate = useNavigate();
  const handleHome = () => {
    if (st.caseId === null || st.caseId === 0 || st.caseId === undefined) {
      navigate('/sop2web/home');
      // reset flag before navigation
      dispatch(caseActions.setDataUpdated(false));
    } else {
      if (st.dataUpdated) {
        setShowDialog(true);
      } else {
        // reset flag before navigation
        dispatch(caseActions.setDataUpdated(false));
        dispatch(caseActions.setViewSummary(true));
      }
    }
    // reset error when navigate out
    if (st.updatecontacterror !== '') dispatch(loginActions.clearError());
  };
  const handleCancel = (event, reason) => {
    if (reason && reason == 'backdropClick') return;
    setShowDialog(false);
    dispatch(caseActions.setViewSummary(true));
    //reset change flag
    dispatch(caseActions.setDataUpdated(false));
    // reset fromMenu
    // setFromMenu(false);
    // reset error when navigate out
    if (st.updatecontacterror !== '') dispatch(loginActions.clearError());
  };
  const submitCaseContactInfo = (values) => {
    dispatch(
      patientActions.persistPatientContactInfo(
        values.addressline1,
        values.addressline2,
        values.city,
        values.state,
        values.country,
        values.zip,
        values.secondaryAddressline1,
        values.secondaryAddressline2,
        values.secondaryCity,
        values.secondaryState,
        values.secondaryCountry,
        values.secondaryZip,
        values.email,
        values.email2,
        values.phone,
        values.phone2,
        values.phone3,
        values.phone4,
        values.phonetype,
        values.phonetype2,
        values.phonetype3,
        values.phonetype4,
        values.languages,
        values.needInterpreter
      )
    );

    var editCaseContactInfoRequest = {
      caseId: st.caseId,
      addressLine1: values.addressline1,
      addressLine2: values.addressline2,
      city: values.city,
      stateProvince:
        values.country !== 'United States' ? values.province : getUSStateAbbr(values.state),
      country: getCountryCode(values.country),
      zip: values.zip,
      secondaryAddressLine1: values.secondaryAddressline1,
      secondaryAddressLine2: values.secondaryAddressline2,
      secondaryCity: values.secondaryCity,
      secondaryStateProvince:
        values.secondaryCountry !== 'United States'
          ? values.secondaryProvince
          : getUSStateAbbr(values.secondaryState),
      secondaryCountry: getCountryCode(values.secondaryCountry),
      secondaryZip: values.secondaryZip,
      email1: values.email,
      email2: values.email2,
      phone1: formatPhoneToSave(countryCode, values.phone),
      phone1Type: getPhoneTypeValue(values.phonetype),
      phone2Type: getPhoneTypeValue(values.phonetype2),
      phone3Type: getPhoneTypeValue(values.phonetype3),
      phone4Type: getPhoneTypeValue(values.phonetype4),
      needInterpreter: values.needInterpreter,
      createOrUpdate: 'update'
    };
    dispatch(caseActions.requestUpdateCaseContactInfo(editCaseContactInfoRequest));
  };

  return (
    <Box>
      <Container>
        <Box
          sx={{
            mt: 3,
            display: 'flex',
            flexDirection: 'row',
            adjustItems: 'center',
            border: 0,
            justifyContent: 'space-between'
          }}>
          <Typography variant="h6">
            {/* Case Info for{' '} */}
            {st !== undefined && st.patient.firstName !== undefined && st.patient.lastName},
            {st !== undefined && st.patient.lastName !== undefined && st.patient.firstName}
            (MRN: {st !== undefined && st.patient.mrn !== undefined ? st.patient.mrn : 'N/A'}){' '}
          </Typography>
        </Box>
        <Divider sx={{ color: '#021D4E', width: 900 }}>Parent/Guardian Information</Divider>

        <Grid container spacing={2}>
          <Grid
            container
            item
            xs={12}
            md={6}
            lg={6}
            direction="column"
            sx={styles.blockContainerStyle}>
            <Box
              sx={{
                justifyContent: 'flex-start',
                border: 0,
                mt: 2,
                width: 400
              }}>
              <Typography
                style={{
                  color: '#021D4E',
                  fontWeight: '500',
                  fontSize: 16,
                  textAlign: 'left'
                }}>
                Are you Parent or Legal Guardian?
              </Typography>
              <Box sx={{ ml: 2, mt: 1 }}>
                <FormControl>
                  <FormLabel id="guarantor-group"></FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="guarantor"
                    name="guarantor"
                    value={formik.values.guarantor}
                    onChange={(e) => {
                      formik.handleChange(e);
                      dispatch(caseActions.setDataUpdated(true));
                    }}>
                    <FormControlLabel
                      value="true"
                      control={<Radio />}
                      label={
                        <Typography
                          style={{
                            color: '#021D4E',
                            fontWeight: '500',
                            fontSize: 15,
                            textAlign: 'left'
                          }}>
                          Yes
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value="false"
                      control={<Radio />}
                      label={
                        <Typography
                          style={{
                            color: '#021D4E',
                            fontWeight: '500',
                            fontSize: 15,
                            textAlign: 'left'
                          }}>
                          No
                        </Typography>
                      }
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
            </Box>
            <Box
              sx={{
                justifyContent: 'flex-start',
                border: 0,
                mt: 2,
                width: 400
              }}>
              <Typography
                style={{
                  color: '#021D4E',
                  fontWeight: '500',
                  fontSize: 16,
                  textAlign: 'left'
                }}>
                Parent/Legal Guardian 1 Name:
              </Typography>
              <TextField
                // size="small"
                sx={{ mr: 5 }}
                variant="standard"
                margin="dense"
                required
                id="firstName"
                label="First name"
                name="firstName"
                // value={propsForm.values.firstName}
                autoComplete="firstName"
                inputProps={{ style: { fontSize: 16 } }}
                InputLabelProps={{ style: { fontSize: 14 } }}
                autoFocus
                value={formik.values.firstName}
                onChange={(e) => {
                  formik.handleChange(e);
                  dispatch(caseActions.setDataUpdated(true));
                }}
                error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                helperText={formik.touched.firstName && formik.errors.firstName}
              />

              <TextField
                // size="small"
                variant="standard"
                margin="dense"
                required
                id="lastName"
                label="Last name"
                name="lastName"
                autoComplete="lastName"
                inputProps={{ style: { fontSize: 16 } }}
                InputLabelProps={{ style: { fontSize: 14 } }}
                value={formik.values.lastName}
                onChange={(e) => {
                  formik.handleChange(e);
                  dispatch(caseActions.setDataUpdated(true));
                }}
                error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                helperText={formik.touched.lastName && formik.errors.lastName}
              />
            </Box>
            <Box
              sx={{
                justifyContent: 'flex-start',
                border: 0,
                mt: 2,
                width: 400
              }}>
              <Typography
                style={{
                  color: '#021D4E',
                  fontWeight: '500',
                  fontSize: 16,
                  textAlign: 'left'
                }}>
                Parent/Legal Guardian 1 relationship to patient?
              </Typography>
              <Autocomplete
                id="preferredSurgeonName"
                sx={{ width: 400 }}
                options={RELATIONSHIP}
                autoHighlight
                getOptionLabel={(option) => {
                  console.log(option);
                  return option.text !== undefined
                    ? option.text
                    : option !== undefined
                    ? option
                    : '';
                }}
                renderOption={(props, option) => (
                  <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                    {option.text}
                  </Box>
                )}
                renderInput={(params) => (
                  <Box>
                    <TextField
                      {...params}
                      // size="small"
                      variant="standard"
                      margin="dense"
                      fullWidth
                      name="patientRelationship"
                      inputProps={{
                        ...params.inputProps,
                        style: { fontSize: 16 }
                      }}
                      InputLabelProps={{
                        style: { fontSize: 14 }
                      }}
                    />
                  </Box>
                )}
                value={formik.values.patientRelationship}
                isOptionEqualToValue={(option, value) => option.text === value}
                onChange={(e, value) => {
                  console.log(value);
                  formik.setFieldValue('patientRelationship', value !== null ? value.text : '');
                  dispatch(caseActions.setDataUpdated(true));
                }}
              />
            </Box>
            <Box
              sx={{
                justifyContent: 'flex-start',
                border: 0,
                mt: 2,
                width: 400
              }}>
              {option !== 'your fetus' && (
                <Box sx={{ mb: 2, mt: 2 }}>
                  <FormControl>
                    <FormLabel id="gender-group">
                      <Typography
                        style={{
                          color: '#021D4E',
                          fontWeight: '500',
                          fontSize: 15,
                          textAlign: 'left'
                        }}>
                        Parent/Guardian 1 Gender:
                      </Typography>
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="gender"
                      name="gender"
                      id="gender"
                      value={formik.values.gender}
                      onChange={(e) => {
                        formik.handleChange(e);
                        dispatch(caseActions.setDataUpdated(true));
                      }}>
                      {GENDER.map((res) => {
                        return (
                          <Box key={res.key}>
                            <FormControlLabel
                              value={res.value}
                              control={<Radio />}
                              label={
                                <Typography
                                  style={{
                                    color: '#021D4E',
                                    fontWeight: '500',
                                    fontSize: 15,
                                    textAlign: 'left'
                                  }}>
                                  {res.text}
                                </Typography>
                              }
                            />
                          </Box>
                        );
                      })}
                    </RadioGroup>

                    {formik.touched.gender && Boolean(formik.errors.gender) && (
                      <Typography style={styles.errorText}>{formik.errors.gender}</Typography>
                    )}
                  </FormControl>
                </Box>
              )}
              <Typography
                style={{
                  color: '#021D4E',
                  fontWeight: '500',
                  fontSize: 16,
                  textAlign: 'left'
                }}>
                Parent/Legal Guardian 1 Date of Birth:
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Box sx={{ mt: 2 }}>
                  {!onMobile && (
                    <DatePicker
                      floatingLabelText="Date"
                      label="Date of birth"
                      size="small"
                      id="dob"
                      maxDate={new Date()}
                      // views={['year', 'month', 'date']}
                      // openTo="year"
                      value={formik.values.dob}
                      // disableFuture
                      // inputFormat="MM.dd.yyyy"
                      // mask="__.__.____"
                      // disableFuture
                      // showTodayButton
                      // onChange={formik.handleChange}
                      onChange={(value) => {
                        formik.setFieldValue('dob', dateToString(value));
                        dispatch(caseActions.setDataUpdated(true));
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                          fullWidth
                          name="dob"
                          inputProps={{ style: { fontSize: 16 } }}
                          InputLabelProps={{ style: { fontSize: 14 } }}
                          value={formik.values.dob}
                          onChange={(value) => {
                            formik.setFieldValue('dob', dateToString(value));
                            dispatch(caseActions.setDataUpdated(true));
                          }}
                          error={formik.touched.dob && Boolean(formik.errors.dob)}
                          helperText={formik.touched.dob && formik.errors.dob}
                        />
                      )}
                    />
                  )}
                  {onMobile && (
                    /*<TextField
                            id="date"
                            label="Date of birth"
                            type="date"
                            required
                            fullWidth
                            inputProps={{ style: { fontSize: 16 } }}
                            InputLabelProps={{ style: { fontSize: 14 } }}
                            // maxDate={new Date()}
                            // value={formik.values.dob}
                            onChange={(value) =>
                              formik.setFieldValue('dob', dateToString(value))
                            }
                            error={formik.touched.dob && Boolean(formik.errors.dob)}
                            helperText={formik.touched.dob && formik.errors.dob}
                          />*/
                    <DatePicker
                      views={['day']}
                      label="Date of birth"
                      maxDate={new Date()}
                      value={formik.values.dob}
                      onChange={(newValue) => {
                        formik.setFieldValue('dob', newValue);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} required fullWidth helperText={'mm/dd/yyyy'} />
                      )}
                    />
                  )}
                </Box>
              </LocalizationProvider>
              {option === 'your fetus' && (
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Box sx={{ mt: 2 }}>
                    {!onMobile && (
                      <DatePicker
                        label="Baby due date"
                        size="small"
                        variant="standard"
                        required
                        fullWidth
                        minDate={new Date()}
                        // inputFormat="MM.dd.yyyy"
                        // mask="__.__.____"
                        value={formik.values.dueDate}
                        onChange={(value) => {
                          formik.setFieldValue('dueDate', dateToString(value));
                          dispatch(caseActions.setDataUpdated(true));
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            // variant="standard"
                            // size="large"
                            required
                            fullWidth
                            // helperText={params?.inputProps?.placeholder}
                            inputProps={{ style: { fontSize: 16 } }}
                            InputLabelProps={{ style: { fontSize: 14 } }}
                            value={
                              formik.values.dueDate == ''
                                ? dateToString(new Date())
                                : formik.values.dueDate
                            }
                            onChange={(value) => {
                              formik.setFieldValue('dueDate', dateToString(value));
                              dispatch(caseActions.setDataUpdated(true));
                            }}
                            error={formik.touched.dueDate && Boolean(formik.errors.dueDate)}
                            helperText={formik.touched.dueDate && formik.errors.dueDate}
                          />
                        )}
                      />
                    )}
                    {onMobile && (
                      /*<TextField
                              label="Baby due date"
                              type="date"
                              required
                              fullWidth
                              inputProps={{ style: { fontSize: 16 } }}
                              InputLabelProps={{ style: { fontSize: 14 } }}
                              // minDate={new Date()}
                              onChange={(value) =>
                                formik.setFieldValue('dueDate', dateToString(value))
                              }
                              error={
                                formik.touched.dueDate &&
                                Boolean(formik.errors.dueDate)
                              }
                              helperText={
                                formik.touched.dueDate && formik.errors.dueDate
                              }
                            />*/
                      <DatePicker
                        views={['day']}
                        label="Baby due date"
                        minDate={new Date()}
                        value={formik.values.dueDate}
                        onChange={(newValue) => {
                          formik.setFieldValue('dueDate', newValue);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth helperText={'mm/dd/yyyy'} />
                        )}
                      />
                    )}
                  </Box>
                </LocalizationProvider>
              )}
            </Box>
            <Box
              sx={{
                justifyContent: 'flex-start',
                border: 0,
                mt: 2,
                width: 400
              }}>
              <Typography
                style={{
                  color: '#021D4E',
                  fontWeight: '500',
                  fontSize: 16,
                  textAlign: 'left'
                }}>
                Parent/Legal Guardian 1 Phone:
              </Typography>
              <MuiPhoneNumber
                fullWidth
                size="small"
                defaultCountry={'us'}
                variant="standard"
                inputProps={{ style: { fontSize: 16 } }}
                sx={{ mt: 2 }}
                id="phone"
                value={formik.values.phone}
                onChange={(value, country) => {
                  console.log(country.dialCode);
                  if (value.includes(' ') && countryCode !== value.split(' ')[0]) {
                    setCountryCode(value.split(' ')[0]);
                    formik.setFieldValue('phone', value);
                  } else {
                    setCountryCode('+' + country.dialCode);
                    formik.setFieldValue('phone', value);
                  }
                  dispatch(caseActions.setDataUpdated(true));
                }}
                error={formik.touched.phone && Boolean(formik.errors.phone)}
                helperText={formik.touched.phone && formik.errors.phone}
              />
            </Box>
            <Box
              sx={{
                justifyContent: 'flex-start',
                border: 0,
                mt: 2,
                width: 400
              }}>
              <Typography
                style={{
                  color: '#021D4E',
                  fontWeight: '500',
                  fontSize: 16,
                  textAlign: 'left'
                }}>
                Parent/Legal Guardian 1 Email:
              </Typography>
              <TextField
                size="small"
                variant="standard"
                margin="dense"
                fullWidth
                id="email"
                name="email"
                autoComplete="email"
                inputProps={{ style: { fontSize: 16 } }}
                InputLabelProps={{ style: { fontSize: 14 } }}
                value={formik.values.email || ''}
                onChange={(e) => {
                  formik.handleChange(e);
                  dispatch(caseActions.setDataUpdated(true));
                }}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
            </Box>
            <Box
              sx={{
                justifyContent: 'flex-start',
                border: 0,
                mt: 2,
                width: 400
              }}>
              {/* <Typography sx={{ my: 0, fontSize: 18, fontWeight: '400' }}>Address</Typography> */}
              <Typography
                style={{
                  color: '#021D4E',
                  fontWeight: '500',
                  fontSize: 16,
                  textAlign: 'left'
                }}>
                Parent/Legal Guardian 1 Address:
              </Typography>
              <Box sx={{ mt: 2 }}>
                <Autocomplete
                  size="small"
                  variant="standard"
                  margin="dense"
                  fullWidth
                  id="country"
                  label="Primary country of residence"
                  sx={{ width: 400 }}
                  options={countries}
                  autoHighlight
                  getOptionLabel={(option) => {
                    console.log(option);
                    return option.label !== undefined
                      ? option.label
                      : option !== undefined
                      ? option
                      : 'United States';
                  }}
                  renderOption={(props, option) => (
                    <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                      <img
                        loading="lazy"
                        width="20"
                        src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                        srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                        alt=""
                      />
                      {option.label} ({option.code})
                    </Box>
                  )}
                  renderInput={(params) => (
                    <Box>
                      <TextField
                        {...params}
                        label="Primary country of residence"
                        size="small"
                        // variant="standard"
                        margin="dense"
                        fullWidth
                        name="country"
                        inputProps={{
                          ...params.inputProps,
                          style: { fontSize: 16 }
                        }}
                        InputLabelProps={{
                          style: { fontSize: 14 }
                        }}
                      />
                    </Box>
                  )}
                  value={formik.values.country}
                  isOptionEqualToValue={(option, value) => option.label === value}
                  onChange={(e, value) => {
                    console.log(value);
                    formik.setFieldValue('country', value.label);
                    dispatch(caseActions.setDataUpdated(true));
                  }}
                />
              </Box>
              <TextField
                size="small"
                variant="standard"
                margin="dense"
                fullWidth
                id="addressline1"
                label="Address line 1"
                name="addressline1"
                autoComplete="addressline1"
                inputProps={{ style: { fontSize: 16 } }}
                InputLabelProps={{ style: { fontSize: 14 } }}
                value={formik.values.addressline1 || ''}
                onChange={(e) => {
                  formik.handleChange(e);
                  dispatch(caseActions.setDataUpdated(true));
                }}
                error={formik.touched.addressline1 && Boolean(formik.errors.addressline1)}
                helperText={formik.touched.addressline1 && formik.errors.addressline1}
              />
              <TextField
                size="small"
                variant="standard"
                margin="dense"
                fullWidth
                id="addressline2"
                label="Address line 2"
                name="addressline2"
                autoComplete="addressline2"
                inputProps={{ style: { fontSize: 16 } }}
                InputLabelProps={{ style: { fontSize: 14 } }}
                value={formik.values.addressline2 || ''}
                onChange={(e) => {
                  formik.handleChange(e);
                  dispatch(caseActions.setDataUpdated(true));
                }}
                error={formik.touched.addressline2 && Boolean(formik.errors.addressline2)}
                helperText={formik.touched.addressline2 && formik.errors.addressline2}
              />
              <TextField
                size="small"
                variant="standard"
                margin="dense"
                fullWidth
                autoFocus
                id="city"
                label="City"
                name="city"
                autoComplete="city"
                inputProps={{ style: { fontSize: 16 } }}
                InputLabelProps={{ style: { fontSize: 14 } }}
                value={formik.values.city || ''}
                onChange={(e) => {
                  formik.handleChange(e);
                  dispatch(caseActions.setDataUpdated(true));
                }}
                error={formik.touched.city && Boolean(formik.errors.city)}
                helperText={formik.touched.city && formik.errors.city}
              />
              {formik.values.country !== 'United States' && (
                <TextField
                  size="small"
                  variant="standard"
                  margin="dense"
                  fullWidth
                  label="Province"
                  name="province"
                  inputProps={{ style: { fontSize: 16 } }}
                  InputLabelProps={{ style: { fontSize: 14 } }}
                  value={formik.values.province}
                  onChange={(e) => {
                    formik.handleChange(e);
                    dispatch(caseActions.setDataUpdated(true));
                  }}
                  error={formik.touched.province && Boolean(formik.errors.province)}
                  helperText={formik.touched.province && formik.errors.province}
                />
              )}
              {formik.values.country === 'United States' && (
                <Autocomplete
                  id="state"
                  sx={{ width: 400 }}
                  options={US_STATES_SORT_BY_NAME}
                  autoHighlight
                  getOptionLabel={(option) => {
                    console.log(option);
                    return option.text !== undefined
                      ? option.text
                      : option !== undefined
                      ? option
                      : '';
                  }}
                  renderOption={(props, option) => (
                    <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                      {option.text}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <Box>
                      <TextField
                        {...params}
                        label="State"
                        size="small"
                        // variant="standard"
                        margin="dense"
                        fullWidth
                        name="state"
                        inputProps={{
                          ...params.inputProps,
                          style: { fontSize: 16 }
                        }}
                        InputLabelProps={{
                          style: { fontSize: 14 }
                        }}
                      />
                    </Box>
                  )}
                  value={formik.values.state}
                  isOptionEqualToValue={(option, value) => option.text === value}
                  onChange={(e, value) => {
                    console.log(value);
                    formik.setFieldValue('state', value !== null ? value.text : '');
                    dispatch(caseActions.setDataUpdated(true));
                  }}
                />
              )}
              <TextField
                size="small"
                variant="standard"
                margin="dense"
                fullWidth
                id="zip"
                label="Zip code"
                name="zip"
                autoComplete="zip"
                inputProps={{ style: { fontSize: 16 } }}
                InputLabelProps={{ style: { fontSize: 14 } }}
                value={formik.values.zip || ''}
                onChange={(e) => {
                  formik.handleChange(e);
                  dispatch(caseActions.setDataUpdated(true));
                }}
                error={formik.touched.zip && Boolean(formik.errors.zip)}
                helperText={formik.touched.zip && formik.errors.zip}
              />
            </Box>
          </Grid>
          <Grid
            container
            item
            xs={12}
            md={6}
            lg={6}
            direction="column"
            sx={styles.blockContainerStyle}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                border: 0,
                mt: 0,
                width: 400
              }}>
              <Box
                sx={{
                  justifyContent: 'flex-start',
                  border: 0,
                  mt: 2,
                  width: 400
                }}>
                <Typography
                  style={{
                    color: '#021D4E',
                    fontWeight: '500',
                    fontSize: 16,
                    textAlign: 'left'
                  }}>
                  Are you Guarantor?
                </Typography>
                <Box sx={{ ml: 2, mt: 1 }}>
                  <FormControl>
                    <FormLabel id="guarantor-group"></FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="guarantor"
                      name="guarantor"
                      value={formik.values.guarantor}
                      onChange={(e) => {
                        formik.handleChange(e);
                        dispatch(caseActions.setDataUpdated(true));
                      }}>
                      <FormControlLabel
                        value="true"
                        control={<Radio />}
                        label={
                          <Typography
                            style={{
                              color: '#021D4E',
                              fontWeight: '500',
                              fontSize: 15,
                              textAlign: 'left'
                            }}>
                            Yes
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        value="false"
                        control={<Radio />}
                        label={
                          <Typography
                            style={{
                              color: '#021D4E',
                              fontWeight: '500',
                              fontSize: 15,
                              textAlign: 'left'
                            }}>
                            No
                          </Typography>
                        }
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>
              <Box
                sx={{
                  justifyContent: 'flex-start',
                  border: 0,
                  mt: 2,
                  width: 400
                }}>
                <Typography
                  style={{
                    color: '#021D4E',
                    fontWeight: '500',
                    fontSize: 16,
                    textAlign: 'left'
                  }}>
                  Parent/Legal Guardian 2 Name:
                </Typography>
                <TextField
                  // size="small"
                  sx={{ mr: 5 }}
                  variant="standard"
                  margin="dense"
                  required
                  id="firstName"
                  label="First name"
                  name="firstName"
                  // value={propsForm.values.firstName}
                  autoComplete="firstName"
                  inputProps={{ style: { fontSize: 16 } }}
                  InputLabelProps={{ style: { fontSize: 14 } }}
                  autoFocus
                  value={formik.values.firstName}
                  onChange={(e) => {
                    formik.handleChange(e);
                    dispatch(caseActions.setDataUpdated(true));
                  }}
                  error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                  helperText={formik.touched.firstName && formik.errors.firstName}
                />

                <TextField
                  // size="small"
                  variant="standard"
                  margin="dense"
                  required
                  id="lastName"
                  label="Last name"
                  name="lastName"
                  autoComplete="lastName"
                  inputProps={{ style: { fontSize: 16 } }}
                  InputLabelProps={{ style: { fontSize: 14 } }}
                  value={formik.values.lastName}
                  onChange={(e) => {
                    formik.handleChange(e);
                    dispatch(caseActions.setDataUpdated(true));
                  }}
                  error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                  helperText={formik.touched.lastName && formik.errors.lastName}
                />
              </Box>
              <Box
                sx={{
                  justifyContent: 'flex-start',
                  border: 0,
                  mt: 2,
                  width: 400
                }}>
                <Typography
                  style={{
                    color: '#021D4E',
                    fontWeight: '500',
                    fontSize: 16,
                    textAlign: 'left'
                  }}>
                  Parent/Legal Guardian 2 relationship to patient?
                </Typography>
                <Autocomplete
                  id="preferredSurgeonName"
                  sx={{ width: 400 }}
                  options={RELATIONSHIP}
                  autoHighlight
                  getOptionLabel={(option) => {
                    console.log(option);
                    return option.text !== undefined
                      ? option.text
                      : option !== undefined
                      ? option
                      : '';
                  }}
                  renderOption={(props, option) => (
                    <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                      {option.text}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <Box>
                      <TextField
                        {...params}
                        // size="small"
                        variant="standard"
                        margin="dense"
                        fullWidth
                        name="patientRelationship"
                        inputProps={{
                          ...params.inputProps,
                          style: { fontSize: 16 }
                        }}
                        InputLabelProps={{
                          style: { fontSize: 14 }
                        }}
                      />
                    </Box>
                  )}
                  value={formik.values.patientRelationship}
                  isOptionEqualToValue={(option, value) => option.text === value}
                  onChange={(e, value) => {
                    console.log(value);
                    formik.setFieldValue('patientRelationship', value !== null ? value.text : '');
                    dispatch(caseActions.setDataUpdated(true));
                  }}
                />
              </Box>
              <Box
                sx={{
                  justifyContent: 'flex-start',
                  border: 0,
                  mt: 2,
                  width: 400
                }}>
                {option !== 'your fetus' && (
                  <Box sx={{ mb: 2, mt: 2 }}>
                    <FormControl>
                      <FormLabel id="gender-group">
                        <Typography
                          style={{
                            color: '#021D4E',
                            fontWeight: '500',
                            fontSize: 15,
                            textAlign: 'left'
                          }}>
                          Parent/Guardian 2 Gender:
                        </Typography>
                      </FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="gender"
                        name="gender"
                        id="gender"
                        value={formik.values.gender}
                        onChange={(e) => {
                          formik.handleChange(e);
                          dispatch(caseActions.setDataUpdated(true));
                        }}>
                        {GENDER.map((res) => {
                          return (
                            <Box key={res.key}>
                              <FormControlLabel
                                value={res.value}
                                control={<Radio />}
                                label={
                                  <Typography
                                    style={{
                                      color: '#021D4E',
                                      fontWeight: '500',
                                      fontSize: 15,
                                      textAlign: 'left'
                                    }}>
                                    {res.text}
                                  </Typography>
                                }
                              />
                            </Box>
                          );
                        })}
                      </RadioGroup>

                      {formik.touched.gender && Boolean(formik.errors.gender) && (
                        <Typography style={styles.errorText}>{formik.errors.gender}</Typography>
                      )}
                    </FormControl>
                  </Box>
                )}
                <Typography
                  style={{
                    color: '#021D4E',
                    fontWeight: '500',
                    fontSize: 16,
                    textAlign: 'left'
                  }}>
                  Parent/Legal Guardian 2 Date of Birth:
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Box sx={{ mt: 2 }}>
                    {!onMobile && (
                      <DatePicker
                        floatingLabelText="Date"
                        label="Date of birth"
                        size="small"
                        id="dob"
                        maxDate={new Date()}
                        // views={['year', 'month', 'date']}
                        // openTo="year"
                        value={formik.values.dob}
                        // disableFuture
                        // inputFormat="MM.dd.yyyy"
                        // mask="__.__.____"
                        // disableFuture
                        // showTodayButton
                        // onChange={formik.handleChange}
                        onChange={(value) => {
                          formik.setFieldValue('dob', dateToString(value));
                          dispatch(caseActions.setDataUpdated(true));
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            required
                            fullWidth
                            name="dob"
                            inputProps={{ style: { fontSize: 16 } }}
                            InputLabelProps={{ style: { fontSize: 14 } }}
                            value={formik.values.dob}
                            onChange={(value) => {
                              formik.setFieldValue('dob', dateToString(value));
                              dispatch(caseActions.setDataUpdated(true));
                            }}
                            error={formik.touched.dob && Boolean(formik.errors.dob)}
                            helperText={formik.touched.dob && formik.errors.dob}
                          />
                        )}
                      />
                    )}
                    {onMobile && (
                      /*<TextField
                            id="date"
                            label="Date of birth"
                            type="date"
                            required
                            fullWidth
                            inputProps={{ style: { fontSize: 16 } }}
                            InputLabelProps={{ style: { fontSize: 14 } }}
                            // maxDate={new Date()}
                            // value={formik.values.dob}
                            onChange={(value) =>
                              formik.setFieldValue('dob', dateToString(value))
                            }
                            error={formik.touched.dob && Boolean(formik.errors.dob)}
                            helperText={formik.touched.dob && formik.errors.dob}
                          />*/
                      <DatePicker
                        views={['day']}
                        label="Date of birth"
                        maxDate={new Date()}
                        value={formik.values.dob}
                        onChange={(newValue) => {
                          formik.setFieldValue('dob', newValue);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} required fullWidth helperText={'mm/dd/yyyy'} />
                        )}
                      />
                    )}
                  </Box>
                </LocalizationProvider>
                {option === 'your fetus' && (
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Box sx={{ mt: 2 }}>
                      {!onMobile && (
                        <DatePicker
                          label="Baby due date"
                          size="small"
                          variant="standard"
                          required
                          fullWidth
                          minDate={new Date()}
                          // inputFormat="MM.dd.yyyy"
                          // mask="__.__.____"
                          value={formik.values.dueDate}
                          onChange={(value) => {
                            formik.setFieldValue('dueDate', dateToString(value));
                            dispatch(caseActions.setDataUpdated(true));
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              // variant="standard"
                              // size="large"
                              required
                              fullWidth
                              // helperText={params?.inputProps?.placeholder}
                              inputProps={{ style: { fontSize: 16 } }}
                              InputLabelProps={{ style: { fontSize: 14 } }}
                              value={
                                formik.values.dueDate == ''
                                  ? dateToString(new Date())
                                  : formik.values.dueDate
                              }
                              onChange={(value) => {
                                formik.setFieldValue('dueDate', dateToString(value));
                                dispatch(caseActions.setDataUpdated(true));
                              }}
                              error={formik.touched.dueDate && Boolean(formik.errors.dueDate)}
                              helperText={formik.touched.dueDate && formik.errors.dueDate}
                            />
                          )}
                        />
                      )}
                      {onMobile && (
                        /*<TextField
                              label="Baby due date"
                              type="date"
                              required
                              fullWidth
                              inputProps={{ style: { fontSize: 16 } }}
                              InputLabelProps={{ style: { fontSize: 14 } }}
                              // minDate={new Date()}
                              onChange={(value) =>
                                formik.setFieldValue('dueDate', dateToString(value))
                              }
                              error={
                                formik.touched.dueDate &&
                                Boolean(formik.errors.dueDate)
                              }
                              helperText={
                                formik.touched.dueDate && formik.errors.dueDate
                              }
                            />*/
                        <DatePicker
                          views={['day']}
                          label="Baby due date"
                          minDate={new Date()}
                          value={formik.values.dueDate}
                          onChange={(newValue) => {
                            formik.setFieldValue('dueDate', newValue);
                          }}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth helperText={'mm/dd/yyyy'} />
                          )}
                        />
                      )}
                    </Box>
                  </LocalizationProvider>
                )}
              </Box>
              <Box
                sx={{
                  justifyContent: 'flex-start',
                  border: 0,
                  mt: 2,
                  width: 400
                }}>
                <Typography
                  style={{
                    color: '#021D4E',
                    fontWeight: '500',
                    fontSize: 16,
                    textAlign: 'left'
                  }}>
                  Parent/Legal Guardian 2 Phone:
                </Typography>
                <MuiPhoneNumber
                  fullWidth
                  size="small"
                  defaultCountry={'us'}
                  variant="standard"
                  inputProps={{ style: { fontSize: 16 } }}
                  sx={{ mt: 2 }}
                  id="phone"
                  value={formik.values.phone}
                  onChange={(value, country) => {
                    console.log(country.dialCode);
                    if (value.includes(' ') && countryCode !== value.split(' ')[0]) {
                      setCountryCode(value.split(' ')[0]);
                      formik.setFieldValue('phone', value);
                    } else {
                      setCountryCode('+' + country.dialCode);
                      formik.setFieldValue('phone', value);
                    }
                    dispatch(caseActions.setDataUpdated(true));
                  }}
                  error={formik.touched.phone && Boolean(formik.errors.phone)}
                  helperText={formik.touched.phone && formik.errors.phone}
                />
              </Box>
              <Box
                sx={{
                  justifyContent: 'flex-start',
                  border: 0,
                  mt: 2,
                  width: 400
                }}>
                <Typography
                  style={{
                    color: '#021D4E',
                    fontWeight: '500',
                    fontSize: 16,
                    textAlign: 'left'
                  }}>
                  Parent/Legal Guardian 2 Email:
                </Typography>
                <TextField
                  size="small"
                  variant="standard"
                  margin="dense"
                  fullWidth
                  id="email"
                  name="email"
                  autoComplete="email"
                  inputProps={{ style: { fontSize: 16 } }}
                  InputLabelProps={{ style: { fontSize: 14 } }}
                  value={formik.values.email || ''}
                  onChange={(e) => {
                    formik.handleChange(e);
                    dispatch(caseActions.setDataUpdated(true));
                  }}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                />
              </Box>
              <Box
                sx={{
                  justifyContent: 'flex-start',
                  border: 0,
                  mt: 2,
                  width: 400
                }}>
                {/* <Typography sx={{ my: 0, fontSize: 18, fontWeight: '400' }}>Address</Typography> */}
                <Typography
                  style={{
                    color: '#021D4E',
                    fontWeight: '500',
                    fontSize: 16,
                    textAlign: 'left'
                  }}>
                  Parent/Legal Guardian 2 Address:
                </Typography>
                <Box sx={{ mt: 2 }}>
                  <Autocomplete
                    size="small"
                    variant="standard"
                    margin="dense"
                    fullWidth
                    id="country"
                    label="Primary country of residence"
                    sx={{ width: 400 }}
                    options={countries}
                    autoHighlight
                    getOptionLabel={(option) => {
                      console.log(option);
                      return option.label !== undefined
                        ? option.label
                        : option !== undefined
                        ? option
                        : 'United States';
                    }}
                    renderOption={(props, option) => (
                      <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                        <img
                          loading="lazy"
                          width="20"
                          src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                          srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                          alt=""
                        />
                        {option.label} ({option.code})
                      </Box>
                    )}
                    renderInput={(params) => (
                      <Box>
                        <TextField
                          {...params}
                          label="Primary country of residence"
                          size="small"
                          // variant="standard"
                          margin="dense"
                          fullWidth
                          name="country"
                          inputProps={{
                            ...params.inputProps,
                            style: { fontSize: 16 }
                          }}
                          InputLabelProps={{
                            style: { fontSize: 14 }
                          }}
                        />
                      </Box>
                    )}
                    value={formik.values.country}
                    isOptionEqualToValue={(option, value) => option.label === value}
                    onChange={(e, value) => {
                      console.log(value);
                      formik.setFieldValue('country', value.label);
                      dispatch(caseActions.setDataUpdated(true));
                    }}
                  />
                </Box>
                <TextField
                  size="small"
                  variant="standard"
                  margin="dense"
                  fullWidth
                  id="addressline1"
                  label="Address line 1"
                  name="addressline1"
                  autoComplete="addressline1"
                  inputProps={{ style: { fontSize: 16 } }}
                  InputLabelProps={{ style: { fontSize: 14 } }}
                  value={formik.values.addressline1 || ''}
                  onChange={(e) => {
                    formik.handleChange(e);
                    dispatch(caseActions.setDataUpdated(true));
                  }}
                  error={formik.touched.addressline1 && Boolean(formik.errors.addressline1)}
                  helperText={formik.touched.addressline1 && formik.errors.addressline1}
                />
                <TextField
                  size="small"
                  variant="standard"
                  margin="dense"
                  fullWidth
                  id="addressline2"
                  label="Address line 2"
                  name="addressline2"
                  autoComplete="addressline2"
                  inputProps={{ style: { fontSize: 16 } }}
                  InputLabelProps={{ style: { fontSize: 14 } }}
                  value={formik.values.addressline2 || ''}
                  onChange={(e) => {
                    formik.handleChange(e);
                    dispatch(caseActions.setDataUpdated(true));
                  }}
                  error={formik.touched.addressline2 && Boolean(formik.errors.addressline2)}
                  helperText={formik.touched.addressline2 && formik.errors.addressline2}
                />
                <TextField
                  size="small"
                  variant="standard"
                  margin="dense"
                  fullWidth
                  autoFocus
                  id="city"
                  label="City"
                  name="city"
                  autoComplete="city"
                  inputProps={{ style: { fontSize: 16 } }}
                  InputLabelProps={{ style: { fontSize: 14 } }}
                  value={formik.values.city || ''}
                  onChange={(e) => {
                    formik.handleChange(e);
                    dispatch(caseActions.setDataUpdated(true));
                  }}
                  error={formik.touched.city && Boolean(formik.errors.city)}
                  helperText={formik.touched.city && formik.errors.city}
                />
                {formik.values.country !== 'United States' && (
                  <TextField
                    size="small"
                    variant="standard"
                    margin="dense"
                    fullWidth
                    label="Province"
                    name="province"
                    inputProps={{ style: { fontSize: 16 } }}
                    InputLabelProps={{ style: { fontSize: 14 } }}
                    value={formik.values.province}
                    onChange={(e) => {
                      formik.handleChange(e);
                      dispatch(caseActions.setDataUpdated(true));
                    }}
                    error={formik.touched.province && Boolean(formik.errors.province)}
                    helperText={formik.touched.province && formik.errors.province}
                  />
                )}
                {formik.values.country === 'United States' && (
                  <Autocomplete
                    id="state"
                    sx={{ width: 400 }}
                    options={US_STATES_SORT_BY_NAME}
                    autoHighlight
                    getOptionLabel={(option) => {
                      console.log(option);
                      return option.text !== undefined
                        ? option.text
                        : option !== undefined
                        ? option
                        : '';
                    }}
                    renderOption={(props, option) => (
                      <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                        {option.text}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <Box>
                        <TextField
                          {...params}
                          label="State"
                          size="small"
                          // variant="standard"
                          margin="dense"
                          fullWidth
                          name="state"
                          inputProps={{
                            ...params.inputProps,
                            style: { fontSize: 16 }
                          }}
                          InputLabelProps={{
                            style: { fontSize: 14 }
                          }}
                        />
                      </Box>
                    )}
                    value={formik.values.state}
                    isOptionEqualToValue={(option, value) => option.text === value}
                    onChange={(e, value) => {
                      console.log(value);
                      formik.setFieldValue('state', value !== null ? value.text : '');
                      dispatch(caseActions.setDataUpdated(true));
                    }}
                  />
                )}
                <TextField
                  size="small"
                  variant="standard"
                  margin="dense"
                  fullWidth
                  id="zip"
                  label="Zip code"
                  name="zip"
                  autoComplete="zip"
                  inputProps={{ style: { fontSize: 16 } }}
                  InputLabelProps={{ style: { fontSize: 14 } }}
                  value={formik.values.zip || ''}
                  onChange={(e) => {
                    formik.handleChange(e);
                    dispatch(caseActions.setDataUpdated(true));
                  }}
                  error={formik.touched.zip && Boolean(formik.errors.zip)}
                  helperText={formik.touched.zip && formik.errors.zip}
                />
              </Box>
            </Box>
          </Grid>
          <Grid
            container
            item
            xs={12}
            md={12}
            lg={12}
            direction="column"
            sx={styles.blockContainerStyle}>
            <Box>
              <Typography style={styles.errorText}>{st.updatecontacterror}</Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                mt: 2,
                border: 0,
                width: 600
              }}>
              <Dialog
                open={showDialog}
                onClose={handleCancel}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{'Save data?'}</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    You are about to leave the form and the form contain unsaved data. Do you want
                    to save?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCancel}>No</Button>
                  <Button
                    onClick={() => {
                      // reset flag
                      dispatch(caseActions.setDataUpdated(false));
                      // reset fromMenu
                      // setFromMenu(false);
                      setShowDialog(false);
                      submitCaseContactInfo(formik.values);
                      dispatch(caseActions.setViewSummary(true));
                    }}
                    autoFocus>
                    Yes
                  </Button>
                </DialogActions>
              </Dialog>
              <Button size="large" variant="contained" sx={{ mb: 5 }} onClick={handleHome}>
                <KeyboardArrowLeft />
                Home
              </Button>
              <Button size="large" variant="contained" onClick={formik.handleSubmit} sx={{ mb: 5 }}>
                Save
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default GuardianInfo;
